<template>
  <b-modal
    title="Sign In"
    v-model="loginDialog"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
  >
    <b-container fluid>
      <b-row class="my-3">
        <b-col sm="12">
          <b-form-input
            size="lg"
            v-model="payload.username"
            placeholder="Username"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col sm="12">
          <b-form-input
            type="password"
            size="lg"
            v-model="payload.password"
            placeholder="Password"
            @keypress.enter="login()"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="alert">
        <b-col sm="12">
          <center style="color: red">{{ warning_text }}</center>
        </b-col>
      </b-row>
    </b-container>
    <b-button class="mt-3" variant="primary" block size="lg" @click="login()"
      >Sign In</b-button
    >
    <b-button
      class="mt-2"
      variant="outline-primary"
      block
      size="lg"
      @click="cancel()"
      >Cancel</b-button
    >

    <div class="mt-3 text-center">
      <b-link class="mt-2" @click="forgotPassword()">Forgot Password</b-link>
    </div>

    <div class="mt-3 text-center">
      <b-link class="mt-2" @click="redirectToSignUp()"
        >Don't have an account? Sign Up Here</b-link
      >
    </div>
  </b-modal>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  data: () => ({
    payload: {
      username: "",
      password: "",
      grant_type: process.env.VUE_APP_GRANT_TYPE,
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
    },
    dialog: true,
    alert: false,
    warning_text: "",
    nextUrlQueryParams: {},
  }),
  computed: {
    ...mapState("dialog", ["loginDialog"]),
    ...mapGetters([
      "getAuthorizationToken",
      "getAuthorizationHeader",
      "hasAuthorizationToken",
    ]),
  },
  methods: {
    ...mapActions(["setAuthorizationToken", "setBaseComponent", "clearAuthorizationToken"]),
    ...mapActions("dialog", ["hideLoginDialog"]),
    ...mapActions("alert", ["setSuccess", "setError"]),
    ...mapActions("user", ["setUser", "getUser", "setMyGroups", "getMyGroups"]),
    login: async function () {
      let that = this;
      that.alert = false;

      if (!that.payload.username.trim() || !that.payload.password.trim()) {
        that.warning_text = "Please enter username and password";
        that.alert = true;
        return;
      }

      // Fetch user token.
      try {
        const tokenResponse = await HTTP.post(
          `/users/api/token/`,
          that.payload
        );
        that.setAuthorizationToken(tokenResponse.data);
        // Get the user info and groups.
        let response = await that.getUser();
        that.setUser(response.data);

        response = await that.getMyGroups();
        that.setMyGroups(response.data);
      } catch (error) {
        that.warning_text = "Invalid credentials or account is deactivated. Try again or reach out to help@vectorbyte.org to reactivate."
        that.alert = true;
      }

      // Get the user info and groups.
      //let response = await that.getUser();
      //that.setUser(response.data);

      //response = await that.getMyGroups();
      //that.setMyGroups(response.data);

      that.payload.username = "";
      that.payload.password = "";

      // Navigate to next if set, otherwise, go to vectorbyte homepage.
      if (that.$route.query.next) {
        that.$router.push({
          path: that.$route.query.next,
          query: that.nextUrlQueryParams,
        });
      } else {
        // this.$router.push({
        //   name: "home"
        // });
        window.location.href = "https://www.vectorbyte.org/";
      }
      that.hide();
    },
    hide: function () {
      this.payload.username = "";
      this.payload.password = "";
      this.alert = false;
      this.hideLoginDialog();
    },
    cancel: function () {
      this.hide();
      this.$router.back();
    },
    forgotPassword: function () {
      this.hide();
      window.location.href = `${process.env.VUE_APP_AXIOS_BASE_URL}/accounts/password/reset/`;
    },
    redirectToSignUp() {
      window.location.href = `${process.env.VUE_APP_AXIOS_BASE_URL}/accounts/signup/`;
    },
    parseUrlQueryParams: function () {
      let nextUrlQueryParams = {};
      for (const [key, value] of Object.entries(this.$route.query)) {
        if (key != "next") {
          nextUrlQueryParams[key] = value;
        }
      }
      return nextUrlQueryParams;
    },
  },
  mounted() {
    this.nextUrlQueryParams = this.parseUrlQueryParams();
  },
};
</script>
